/* eslint-disable react/no-array-index-key */
import {
  Avatar,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import moment from 'moment';
import { useScroll, useUpdateEffect } from 'react-use';

import React, { useEffect, useRef, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  listBox: {
    width: '100%',
    display: 'flex',
    height: '528px',
    overflowY: 'auto',
    flexDirection: 'column',
    paddingRight: theme.spacing(2),
  },
  listItem: {
    flexFlow: 'row nowrap',
    alignItems: 'stretch',
  },
  listADialog: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'stretch',
    flexShrink: 40,
    maxWidth: `calc(100% - calc(40px + ${theme.spacing(2)}))`,
    minHeight: 40,
    gap: theme.spacing(0.5),
  },
  listQDialog: {
    minHeight: 40,
    display: 'flex',
    flexFlow: 'row wrap-reverse',
    alignItems: 'stretch',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
  a: {
    borderTopLeftRadius: 0,
    background: theme.palette.action.hover,
  },
  q: {
    borderTopLeftRadius: 0,
    background: theme.palette.secondary.light,
  },
  dialogText: {
    alignSelf: 'end',
    wordBreak: 'keep-all',
    padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    fontSize: theme.typography.body2.fontSize,
    borderRadius: theme.shape.borderRadius,
  },
  dialogDate: {
    fontSize: '9px',
    wordBreak: 'keep-all',
    alignSelf: 'end',
    opacity: 0.5,
    letterSpacing: -0.25,
  },
}));

const HistoryList = ({ data, robot, pending, bTop, handleLoad }) => {
  // 여기서 넘겨받은 로봇 정보로 user 정보를 요청해올것
  // const user = '/img_user.png';
  const classes = useStyles();
  const scrollRef = useRef(null);
  const { y: scrollY } = useScroll(scrollRef);
  const [lastY, setLast] = useState(0);

  const scrollTop = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0 });
    }
  };

  useEffect(() => {
    if (scrollY === 0) {
      setLast(0);
    }
    const { scrollHeight, clientHeight } = scrollRef.current;
    const scrollEnd = scrollHeight - clientHeight;
    if (
      scrollY !== 0 &&
      scrollEnd - 5 <= scrollY &&
      scrollY <= scrollEnd + 5 &&
      lastY < scrollEnd
    ) {
      setLast(scrollEnd);
      handleLoad();
    }
  }, [scrollY]);

  useUpdateEffect(() => scrollTop(), [bTop]);

  return (
    <Box className={classes.listBox} ref={scrollRef}>
      {!robot && (
        <Typography>
          좌측의 로봇 목록에서 히스토리를 확인하고 싶은 로봇의 보기 버튼을
          선택하세요.
        </Typography>
      )}
      {robot &&
        data.map((dataitem) =>
          Object.entries(dataitem).map(([date, list]) => (
            <Box key={date} sx={{ mb: 2, width: '100%' }}>
              <Divider>
                <Typography variant="body2" textAlign="center">
                  {date}
                </Typography>
              </Divider>
              {pending && <CircularProgress color="secondary" size="small" />}
              {list.map(({ q, a, id, firstTime }) => (
                <Stack key={id} sx={{ mb: 1 }}>
                  <Stack direction="row" className={classes.listItem}>
                    <Avatar src="/pibo-torso.png" alt="pibo" />
                    <Box className={classes.listADialog}>
                      <Typography
                        component="span"
                        className={`${classes.dialogText} ${classes.a}`}
                      >
                        {a}
                      </Typography>
                      <Typography
                        component="span"
                        className={classes.dialogDate}
                      >
                        {moment(firstTime).format('lll')}
                      </Typography>
                    </Box>
                  </Stack>
                  {q && (
                    <Box
                      className={classes.listQDialog}
                      sx={{ justifyContent: 'flex-end' }}
                    >
                      <Typography
                        component="span"
                        className={classes.dialogDate}
                      >
                        {moment(firstTime).format('lll')}
                      </Typography>
                      <Typography
                        component="span"
                        className={`${classes.dialogText} ${classes.q}`}
                      >
                        {q}
                      </Typography>
                    </Box>
                  )}
                </Stack>
              ))}
            </Box>
          )),
        )}
    </Box>
  );
};

export default HistoryList;
